import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Currencyhelper from './Currency';

import cls from './styleOptions.module.scss';

class Options {
  static optionsReactFilestack(value = 1) {
    return {
      accept: 'image/*',
      maxFiles: value,
      transformations: {
        crop: true,
        circle: false,
        rotate: true,
      },
      fromSources: [
        'local_file_system',
        'url',
        'imagesearch',
        'facebook',
        'instagram',
        'googledrive',
        'dropbox',
        'webcam',
        'video',
        'audio',
      ],
      storeTo: {
        location: 's3',
      },
    };
  }

  static optionsCurrency() {
    const currency = {
      EUR: 'url("https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg")',
      USD: 'url("https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg")',
      GBP: 'url("https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg")',
      RUB: 'url("https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Russia.svg")',
    };
    return Object.keys(currency).map((el) => ({
      value: el,
      label: (
        <span>
          <span
            className={cls.headerLangImg}
            style={{
              backgroundImage: currency[el],
            }}
          />
          <span>
            {el} - <span>{Currencyhelper.getCurrencySymbol(el)}</span>
          </span>
        </span>
      ),
    }));
  }

  static optionsCurrencyMUI() {
    const currency = {
      EUR: 'https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg',
      USD: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg',
      GBP: 'https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg',
      RUB: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Russia.svg',
    };
    return Object.keys(currency).map((el) => (
      <MenuItem value={el} key={el} button>
        <span
          className={cls.headerLangImg}
          style={{
            backgroundImage: `url("${currency[el]}")`,
          }}
        />

        <span>
          {el} - <span>{Currencyhelper.getCurrencySymbol(el)}</span>
        </span>
      </MenuItem>
    ));
  }
}

export default Options;
